import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchFeatureFlags } from '../../ducks/featureFlags';
import styled from '../../theme';
import Footer from '../Footer';
import Header from '../Header';

const App: React.FunctionComponent = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(fetchFeatureFlags());
  }, [dispatch, location.pathname]);

  return (
    <StyledApp>
      <Header />
      <StyledAppMain>{children}</StyledAppMain>
      <Footer />
    </StyledApp>
  );
};

const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const StyledAppMain = styled.main`
  display: flex;
  width: 100%;
  margin: auto;
  flex-grow: 1;
  z-index: 0;
`;

export default App;
